import React from 'react';
import {
  SpacingName,
  TypographyName,
} from '@doveit/lego';
import PageSection from '../../components/page-section/PageSection';
import ArticleMarkdown from '../../components/article-markdown/ArticleMarkdown';
import CardsHList from '../../components/cards-hlist/CardsHList';
import ArticleVerticalCard from '../../components/article-vertical-card/ArticleVerticalCard';
import { buildArticleURLObject, goToPage, slugIt } from '../../utils/links';
import { ArticlePreview } from '../types';
import { ArticleType } from '../../../domain/articleType';
import Markdown from '../../components/markdown/Markdown';

export interface NewsSectionProps {
  title: string,
  content: string,
  news: ArticlePreview[],
}

export const NewsSection: React.FC<NewsSectionProps> = ({
  title,
  content,
  news = [],
}) => {
  const normalizedNews = React.useMemo(() => news.map((newItem) => ({
    ...newItem,
    urlObject: buildArticleURLObject({
      id: newItem.id,
      slug: slugIt(newItem.alternateTitle || newItem.title),
    }, ArticleType.NEWS),
  })), [news]);

  return (
    <PageSection>
      <PageSection.Wrapper>
        <PageSection.Title size={TypographyName.H3}>
          <Markdown>
            {title.trim()}
          </Markdown>
        </PageSection.Title>
        {content && (
          <PageSection.Block>
            <ArticleMarkdown>
              {content.trim()}
            </ArticleMarkdown>
          </PageSection.Block>
        )}
      </PageSection.Wrapper>
      <PageSection.Wrapper withoutPad>
        <PageSection.Block>
          <CardsHList sideSpacing={SpacingName.SMALL}>
            {normalizedNews.map((article) => (
              <CardsHList.Item key={article.id}>
                <ArticleVerticalCard
                  title={article.alternateTitle || article.title}
                  abstract={article.abstract}
                  imageURL={article.image.url}
                  imageAlt={article.image.alt}
                  onClick={() => goToPage(article.urlObject)}
                  urlObject={article.urlObject}
                />
              </CardsHList.Item>
            ))}
          </CardsHList>
        </PageSection.Block>
      </PageSection.Wrapper>
    </PageSection>
  );
};

export default NewsSection;
